module.exports = __webpack_public_path__ + "media/images/flags/64/Marshall-Islands-e52ab3c6512513ef674fdd8dce0f0f01.png";